<template>
    <b-form @submit.stop.prevent="saveBillingInfo">
        <b-card :header="$t('billingInformation')">
            <b-row cols="2" class="mb-4">
                <b-col>
                    <b-form-checkbox name="type" value="person" v-model="billingAddress.type"
                    > {{ $t('billingAddress.person')  }} </b-form-checkbox>
                </b-col>

                <b-col>
                    <b-form-checkbox name="type" value="company" v-model="billingAddress.type"
                    > {{ $t('billingAddress.company')  }} </b-form-checkbox>
                </b-col>
            </b-row>

            <div v-if="billingAddress.type == 'person'">

                <SelectField name="country" :label="this.$t('country')" v-model="billingAddress.country" @error="(e) => { fieldError(e, 'personBillingErrors') }"
                    :items="countries"
                    :reduce="(o) => o"
                    :rules="{required:true, length: {min: 2}}"
                    v-if="countries"
                />

                <InputField name="firstname" :label="this.$t('firstname')" v-model="billingAddress.firstname" @error="(e) => { fieldError(e, 'personBillingErrors') }"
                    :rules="{required:true, length: {min: 2}}"
                />

                <InputField name="lastname" :label="this.$t('lastname')" v-model="billingAddress.lastname" @error="(e) => { fieldError(e, 'personBillingErrors') }"
                    :rules="{required:true, length: {min: 2}}"
                />

                <InputField name="address" :label="this.$t('address')" v-model="billingAddress.address" @error="(e) => { fieldError(e, 'personBillingErrors') }"
                    :rules="{required:true, length: {min: 2}}"
                />

                <InputField name="city" :label="this.$t('city')" v-model="billingAddress.city" @error="(e) => { fieldError(e, 'personBillingErrors') }"
                    :rules="{required:true, length: {min: 2}}"
                />

                <InputField name="zipcode" :label="this.$t('zipcode')" v-model="billingAddress.zipcode" @error="(e) => { fieldError(e, 'personBillingErrors') }"
                    :rules="{required:false, length: {min: 2}}"
                />

                <InputField name="state" :label="this.$t('state')" v-model="billingAddress.state" @error="(e) => { fieldError(e, 'billingErrors') }"
                    :rules="{required:false, length: {min: 2}}"
                />

                <InputField type="email" name="email" :label="this.$t('email')" v-model="billingAddress.email" @error="(e) => { fieldError(e, 'billingErrors') }"
                    :rules="{required:true, length: {min: 2}}"
                />
            </div>

            <div v-if="billingAddress.type == 'company'">

                <protokol-invalid-feedback :errors="validator.fieldErrors('country')">
                    <b-form-group
                        :label="$t('country')"
                    >
                        <protokol-input-select name="country"  v-model="billingAddress.country"
                            :options="countries"
                            v-if="countries"
                        />
                    </b-form-group>
                </protokol-invalid-feedback>

                <protokol-invalid-feedback :errors="validator.fieldErrors('vat_number')">
                    <b-form-group
                        :label="this.$t('vat')" 
                        :description="billingAddress.country == 'Serbia' ? this.$t('enteringVatNumberAutoSearch') : ''"
                    >
                        <b-form-input name="vat_number" v-model="billingAddress.vat_number"></b-form-input>
                    </b-form-group>
                </protokol-invalid-feedback>

                <template v-if="billingAddress.country == 'Serbia'">
                    <protokol-invalid-feedback :errors="validator.fieldErrors('main_number')">
                        <b-form-group
                         :label="this.$t('billingAddress.mainNumber')"
                        >
                            <b-form-input name="main_number"  v-model="billingAddress.main_number"
                                v-if="billingAddress.country == 'Serbia'"
                            />
                        </b-form-group>
                    </protokol-invalid-feedback>

                    <!-- <b-form-group
                        v-if="billingAddress.country == 'Serbia'"
                        :label="`${$t('billingAddress.sefUser')}`"
                        label-for="sef_user"
                        :label-cols="5"
                        label-cols-sm="5"
                        :horizontal="false">
                        <c-switch class="mx-1" color="success" variant="pill" :label="true" :dataOn="`${$t('yes')}`" :dataOff="`${$t('no')}`" v-model="billingAddress.sef_user"/>
                    </b-form-group> -->
                </template>

                <protokol-invalid-feedback :errors="validator.fieldErrors('company')">
                    <b-form-group
                        :label="this.$t('billingAddress.companyName')" 
                    >
                        <b-form-input name="company" v-model="billingAddress.company" ></b-form-input>
                    </b-form-group>
                </protokol-invalid-feedback>


                <InputField type="email" name="email" :label="this.$t('email')" v-model="billingAddress.email" @error="(e) => { fieldError(e, 'billingErrors') }"
                    :rules="{required:false, length: {min: 2}}"
                />

                <protokol-invalid-feedback :errors="validator.fieldErrors('address')">
                    <b-form-group
                        :label="this.$t('address')"
                    >
                        <b-form-input name="address" v-model="billingAddress.address" />
                    </b-form-group>
                </protokol-invalid-feedback>

                <protokol-invalid-feedback :errors="validator.fieldErrors('city')">
                    <b-form-group
                        :label="this.$t('city')"
                    >
                        <b-form-input name="city" v-model="billingAddress.city" />
                    </b-form-group>
                </protokol-invalid-feedback>

                <InputField name="zipcode" :label="this.$t('zipcode')" v-model="billingAddress.zipcode" @error="(e) => { fieldError(e, 'billingErrors') }"
                    :rules="{required:false, length: {min: 2}}"
                />

                <InputField name="state" :label="this.$t('state')" v-model="billingAddress.state" @error="(e) => { fieldError(e, 'billingErrors') }"
                    :rules="{required:false, length: {min: 2}}"
                />
                
            </div>

            <b-form-group
                :label-cols="1"
                :horizontal="true">
                <button class="btn btn-success pull-right" type="submit">{{ $t('save') }}</button>
            </b-form-group>
        </b-card>
    </b-form>
</template>
<script>
import Input from "@/components/form/Input"
import Select from "@/components/form/Select"
import publicHttp from "@/shared/publicHttp"
import Vue from 'vue'

export default {
    components: {
        InputField: Input,
        SelectField: Select
    },
    data: function() {
        return {
            personBillingErrors: [],
            billingErrors: [],
            countries: null,
            typeOptions: [
                {
                    text: this.$t('billingAddress.person'),
                    value: 'person'
                },
                {
                    text: this.$t('billingAddress.company'),
                    value: 'company'
                }
            ],
            billingAddress: null,
            validator: this.$validator()
        }
    },

    watch: {
        'billingAddress.vat_number': function(n, o) {
            if (this.billingAddress.country != "Serbia") return
            
            if (n.length == 9) {
                this.$integrationApi.get("/invoicing/services/nbs/search?vatNumber=" + n).then((resp) => {
                    let info = resp.data

                    Vue.set(this.billingAddress, 'main_number', info.mb)
                    Vue.set(this.billingAddress, 'company', info.name)
                    Vue.set(this.billingAddress, 'address', info.address)
                    Vue.set(this.billingAddress, 'city', info.place)

                    this.validator.revalidate()
                }).catch(() => {
                    if (o.length != 0) {
                        this.$bvToast.toast(this.$t('companyVatSearchSerbiaError'), {
                            title: this.$t('error'),
                            variant: 'danger'
                        })
                    }
                })
            }
        },

        billingAddress: {
            handler: function() {
                this.validator.revalidate()
            },

            deep: true
        }
    },

    methods: {
        fieldError(error, errorBag) {
            let bag = errorBag || "errors"
            let errors = this[bag]

            let found = errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                errors.push(error)
            } else {
                errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors(errorBag) {
            let bag = errorBag || "errors"
            let errors = this[bag]

            return errors.find((i, e) => {
                return i.error
            })
        },

        saveBillingInfo(e) {
            e.preventDefault()

            if (!this.validator.pass()) {
                this.$bvToast.toast(this.$t('fieldsNotValid'), {
                    variant: 'danger',
                    title: this.$t('error')
                })

                return
            }

            if (this.password !== this.confirm_password) {
                this.$bvModal.msgBoxOk(this.$t('passwordNotValid'))

                return
            }

            let model = {
                name: this.user.name,
                email: this.user.email,
                settings: this.settings,
                billing_address: this.billingAddress
            }

            if (this.password != "") {
                model["password"] = this.password
            }

            this.$http.post("/v1/user/profile/edit", model).then(resp => {
                this.$emit('saved', model)

                this.$store.commit("SET_BILLING_ADDRESS", this.billingAddress)
            }).catch(error => {
                if (error.response.status == 500) {
                    this.$serverErrorModal(error)
                    return
                }

                this.$bvModal.msgBoxOk(error.response.data.message)
            })
        }
    },

    computed: {
        isVatRequired() {
            return true
        },

        user() {
            return this.$store.getters.getUser
        }
    },

    mounted() {
        publicHttp.get("https://restcountries.com/v3.1/all").then(resp => {
            this.countries = resp.data.map(d => {
                return d.name.common
            })
        })

        this.billingAddress = this.$store.getters.getUser.settings.billing_address || {}

        this.validator.validate(this.billingAddress, {
            default: (model, errors) => {
                if (!model.country) errors.add('country', [this.$t('fieldRequired')])
                if (!model.vat_number) errors.add('vat_number', [this.$t('fieldRequired')])
                if (!model.main_number && model.country == 'Serbia') errors.add('main_number', [this.$t('fieldRequired')])
                if (!model.company) errors.add('company', [this.$t('fieldRequired')])
                if (!model.address) errors.add('address', [this.$t('fieldRequired')])
                if (!model.city) errors.add('city', [this.$t('fieldRequired')])

                return errors
            },
        })
    }
}
</script>